export default __webpack_public_path__ + "static/media/KZ.Т.12.2528 Kazaly black.3c46d210.svg";